import { ALL_BUTTON_POSITION_LIST } from '@/common/manager/position/button-position';
import isFunction from 'lodash/isFunction';
export const config = {
    value: 'componentReRender',
    position: ALL_BUTTON_POSITION_LIST,
    action: (arg) => {
        const { buttonConfig, _context } = arg || {};
        const { options = {} } = buttonConfig;
        const { _bindComponent } = options;
        function reloadOneComponent(id) {
            if (typeof id === 'string') {
                const compIns = _context.$(id);
                if (isFunction(compIns?.reRender)) {
                    compIns?.reRender?.()?.();
                }
                else {
                    compIns?.forceUpdate?.();
                }
            }
        }
        if (_bindComponent && _context) {
            if (Array.isArray(_bindComponent)) {
                _bindComponent.forEach((item) => {
                    reloadOneComponent(item);
                });
            }
            else {
                reloadOneComponent(_bindComponent);
            }
        }
    },
};
